import { createApiRequest } from "../common";
import { UpdateOrgThemeRequestContent, UpdateOrgThemeResponseContent } from '@equaliq/api-model';

export const updateOrgThemeApi = async (request: UpdateOrgThemeRequestContent): Promise<UpdateOrgThemeResponseContent> => {
  const apiRequest = createApiRequest<UpdateOrgThemeResponseContent>('post', '/orgs/updateOrgTheme');
  return apiRequest(request);
};
